import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { categories, getArticlesByCategory, getCategoryBySlug } from '@/mocks/data';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || categories[0].slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    if (slug) setActiveCategory(slug);
  }, [slug]);

  const category = getCategoryBySlug(activeCategory);
  const categoryArticles = getArticlesByCategory(activeCategory);

  if (!category) {
    return (
      <div className="pt-20 pb-16 text-center">
        <p className="text-foreground-500">分类未找到</p>
      </div>
    );
  }

  return (
    <div className="pt-20 pb-16">
      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: category.name },
        ]}
      />

      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {category.name}
          </h1>
          <p className="text-foreground-600 max-w-[600px]">
            {category.description}
          </p>
          <p className="text-sm text-foreground-400 mt-2">
            共 {categoryArticles.length} 篇文章
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-10">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categoryArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        {categoryArticles.length === 0 && (
          <div className="text-center py-20 text-foreground-400">
            该分类暂无文章
          </div>
        )}
      </div>
    </div>
  );
}